import { Component, inject, OnInit, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";

import { BlogService } from "../../../shared/services/blog.service";
import { ExternalpageSingle } from "../../../class/externalpage-single";
import { ImageService } from "../../../shared/services/image.service";

@Component({
  selector: "app-page-blog-post",
  templateUrl: "./page-blog-post.component.html",
  styleUrls: ["./page-blog-post.component.scss"],
  standalone: false,
})
export class PageBlogPostComponent
  extends ExternalpageSingle
  implements OnInit
{
  override readonly maxRelatedDataItems = 6;

  private readonly blogService = inject(BlogService);
  private readonly route = inject(ActivatedRoute);
  readonly imageService = inject(ImageService);

  public relatedData = signal<any[]>([]);

  constructor() {
    super();
  }

  ngOnInit(): void {
    // Only load data if entity hasn't been provided by parent (dynamic component loading)
    if (!this.entity || !this.entity.id) {
      this.route.params
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((routeParams) => {
          this.onIdChange();
          this.loadSingle(routeParams["id"]);
        });
    } else {
      // Entity data provided by parent component, just run callbacks
      this.parseImages();
      this.loadCallback();
      this.setMetaTags();
    }
  }

  override loadCallback(): void {
    this.setRelatedData(this.entity.id);
  }

  setRelatedData(id: string | null): void {
    this.relatedData.set([]);
    const tmp = this.blogService.homeData;
    if (tmp.length === 0) {
      this.blogService.$homeDataSubject
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          const items: any[] = [];
          for (const item of this.blogService.homeData) {
            if (item["id"] !== id && items.length < this.maxRelatedDataItems) {
              items.push(item);
            }
          }
          this.relatedData.set(items);
        });
    } else {
      const items: any[] = [];
      for (const item of tmp) {
        if (item["id"] !== id && items.length < this.maxRelatedDataItems) {
          items.push(item);
        }
      }
      this.relatedData.set(items);
    }
  }
}

export interface SingleBlogPost {
  id: "";
  title: "";
  content: "";
  image_url: "";
  video_url: "";
}
